module.exports = __webpack_public_path__ + "Cabins-5598026e81fc5b826af651f491a67466.png";